import { preventSubmitOnEnter } from '../booking-questions-editor.utils'
import type { AddOptionInputProps } from './add-option-input.interface'
import classes from './add-option-input.module.scss'

const ADD_OPTION_PLACEHOLDER = 'Add an option…'

/** Always empty: the first character typed becomes a new option row, which takes the focus. */
export function AddOptionInput({ disabled, onAdd }: AddOptionInputProps) {
  return (
    <input
      className={classes.root}
      value=""
      placeholder={ADD_OPTION_PLACEHOLDER}
      aria-label="Add an option"
      disabled={disabled}
      onChange={(event) => event.target.value && onAdd(event.target.value)}
      onKeyDown={preventSubmitOnEnter}
    />
  )
}
